/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Venues_SelectInputs */

const cs_settings_venues_select = /** @type {(inputs: Settings_Venues_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyberte pobočku`)
};

const en_settings_venues_select = /** @type {(inputs: Settings_Venues_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select an office`)
};

/**
* | output |
* | --- |
* | "Select an office" |
*
* @param {Settings_Venues_SelectInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_venues_select = /** @type {((inputs?: Settings_Venues_SelectInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Venues_SelectInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_venues_select(inputs)
	return cs_settings_venues_select(inputs)
});